/* global Models */

Models.DateRange = function (config) {
    /* private properties and methods */
    var ranges = {
        'Dnes': [moment(), moment()],
        'Včera': [moment().subtract('days', 1), moment().subtract('days', 1)],
        //'Posledních 7 dnů': [moment().subtract('days', 6), moment()],
        //'Posledních 30 dnů': [moment().subtract('days', 29), moment()],
        'Minulý týden': [moment().startOf('week').subtract('days', 6), moment().endOf('week').subtract('days', 6)],
        'Tento týden': [moment().startOf('week').add('days', 1), moment().endOf('week').add('days', 1)],
        'Minulý měsíc': [moment().subtract('month', 1).startOf('month'), moment().subtract('month', 1).endOf('month')],
        'Tento měsíc': [moment().startOf('month'), moment().endOf('month')]
    };
    var locale = {
        applyLabel: 'Použít',
        cancelLabel: 'Zrušit',
        fromLabel: 'od',
        toLabel: 'do',
        weekLabel: 'T',
        customRangeLabel: 'Vlastní rozsah',
        monthNames: 'Leden_Únor_Březen_Duben_Květen_Červen_Červenec_Srpen_Září_Říjen_Listopad_Prosinec'.split('_'),
        daysOfWeek: 'Ne_Po_Út_St_Čt_Pá_So'.split('_'),
        firstDay: 1
    };
    var id = null;
    var container = null;

    /* public properties and methods */
    this.startDate = moment();
    this.endDate = moment();
    this.getId = function () {
        return id;
    };
    this.setId = function ($id) {
        id = $id;
    };
    this.init = function () {
        container = $("#" + id);
        container.daterangepicker({
            ranges: ranges,
            locale: locale,
            startDate: this.startDate,
            endDate: this.endDate
        }, function (start, end) {
            $("#" + id + " span").html(start.format('DD.MM.YYYY') + ' - ' + end.format('DD.MM.YYYY'));
            $("#" + id + " input").first().val(start.format('DD.MM.YYYY 00:00:00'));
            $("#" + id + " input").last().val(end.format('DD.MM.YYYY 00:00:00'));
        });
    };

    /* constructor */
    if (!config.id) return null;
    id = config.id;
    this.startDate = config.startDate;
    this.endDate = config.endDate;
    this.init();
};
